import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Card, CardActions, CardContent, Container, Grid, Typography } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { useStyles } from './LoginStyles';
import { getTranslationsByBrokerId } from './LoginService';
import { useAppData } from '../../providers';
import { extractLocaleFromPath, getURLParam, languages, supportedLocales } from '../../utils';
import { Footer, UnauthorizedHeader } from '../../components';

export const ErrorPage: FC = () => {
  const classes = useStyles();
  const { logoUrl, footerLogoUrl, saveTranslations, saveLocale } = useAppData();
  const [logo, setLogo] = useState<string>('');
  const [footerLogo, setFooterLogo] = useState<string>('');
  const [translation, setTranslation] = useState<any>([]);
  const [selectedLocale, setSelectedLocale] = useState<any>(languages[0]);
  const location = useLocation();
  const lang = extractLocaleFromPath(location.pathname);

  const brokerId = getURLParam('BrokerId');

  useEffect(() => {
    setLogo(logoUrl);
    setFooterLogo(footerLogoUrl);
  }, [logoUrl, footerLogoUrl]);

  const getTranslationList = useCallback(
    async (broker: string) => {
      const translations = await getTranslationsByBrokerId(broker);
      saveTranslations(JSON.stringify(translations.data));
      setTranslation(translations.data);
    },
    [saveTranslations],
  );

  const handleLocaleChange = useCallback(
    async (event: React.ChangeEvent<{ value: unknown }>) => {
      const selectedLanguage = languages.find((item) => item.value === (event.target.value as string)) || languages[0];
      setSelectedLocale(selectedLanguage);
      saveLocale(selectedLanguage.value);
      await getTranslationList(brokerId);
    },
    [getTranslationList, brokerId, saveLocale],
  );

  useEffect(() => {
    if (brokerId) {
      (async () => {
        if (lang && supportedLocales.includes(lang)) {
          const selectedLanguage = languages.find((item) => item.value === lang) || languages[0];
          setSelectedLocale(selectedLanguage);
          await getTranslationList(brokerId);
        } else {
          await getTranslationList(brokerId);
        }
      })();
    }
  }, [getTranslationList, brokerId, lang]);

  return (
    <Grid container direction="column" className={classes.root}>
      <Grid item>
        <UnauthorizedHeader logo={logo} selectedLocale={selectedLocale} handleLocaleChange={handleLocaleChange} />
      </Grid>
      <Grid item className={classes.margin}>
        <Container className={classes.errorContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Typography variant="h5">{translation.text_1582}</Typography>
              <Typography variant="body1">{translation.text_1583}</Typography>
            </CardContent>
            <CardActions className={classes.errorCardActions}>
              <Button fullWidth variant="contained" color="primary" href={`${process.env.REACT_APP_URL_REGISTER_LINK}?flowkey=ibrequest`}>
                Register
              </Button>
            </CardActions>
          </Card>
        </Container>
      </Grid>
      <Grid item>
        <Footer translation={translation} logo={footerLogo} />
      </Grid>
    </Grid>
  );
};
